import { render } from "./ItemView.vue?vue&type=template&id=c2f90f2a&scoped=true"
import script from "./ItemView.vue?vue&type=script&lang=js"
export * from "./ItemView.vue?vue&type=script&lang=js"

import "./ItemView.vue?vue&type=style&index=0&id=c2f90f2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f90f2a"]])

export default __exports__